import React from "react";
import { MessageCircle } from "lucide-react";
import { GALLERY_IMAGES, MESSENGER_URL } from "@/data/staycation";
import Seo from "@/components/Seo";

export default function Gallery() {
  return (
    <div data-testid="gallery-page">
      <Seo
        title="Photo Gallery — Real photos of our staycation units"
        description="Browse 31 real photos of Xanders Staycation units at Shell, Shore 1, Shore 2 and South Residences. Pool views, balconies, kitchens — see exactly what you'll book."
        path="/gallery"
      />
      <section className="mx-auto max-w-7xl px-5 lg:px-8 pt-14 pb-10">
        <p className="xs-eyebrow">Photo Gallery</p>
        <h1 className="font-display text-4xl sm:text-5xl font-black mt-2 max-w-2xl">A peek inside our cozy units & sun-soaked amenities.</h1>
        <p className="mt-4 text-neutral-600 max-w-xl">Real units, real comfort. Tap any unit page to ask about a specific layout — we'll send you fresh photos via Messenger.</p>
      </section>

      <section className="mx-auto max-w-7xl px-5 lg:px-8 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-6" data-testid="gallery-images-grid">
          {GALLERY_IMAGES.map((img, idx) => (
            <figure
              key={idx}
              data-testid={`gallery-item-${idx}`}
              className={`relative overflow-hidden rounded-2xl xs-card ${img.span || ""}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="xs-img w-full h-auto object-contain bg-white"
              />
            </figure>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 lg:px-8 pb-24">
        <div className="rounded-3xl bg-white border border-neutral-200 p-8 sm:p-12 text-center">
          <h3 className="font-display text-2xl sm:text-3xl font-bold">Want to see more photos of a specific unit?</h3>
          <p className="mt-3 text-sm text-neutral-600 max-w-xl mx-auto">Send us a quick message and we'll share fresh, real photos of your preferred unit and dates.</p>
          <a
            href={MESSENGER_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="gallery-messenger-cta"
            className="xs-btn-primary mt-6 inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold"
          >
            <MessageCircle className="h-4 w-4" /> Ask on Messenger
          </a>
        </div>
      </section>
    </div>
  );
}
